import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnChange(props) {
  let full_day_default = useDataValue({
    context: 'settings',
    path: 'full_day_default',
    viewPath: props.viewPath,
  })

  let submit = useDataSubmit({
    context: 'settings',
    viewPath: props.viewPath,
  })

  return function onChange() {
    return submit({
      key: 'full_day_default',
      value: !full_day_default,
    })
  }
}
